import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ApplicantStage } from "./config";

const STAGE_ROUTES: Record<number, string> = {
  [ApplicantStage.PanVerification]:       "/eligibility/income",
  [ApplicantStage.AddressDetails]:        "/eligibility/bank-statement",
  [ApplicantStage.EmploymentDetails]:     "/eligibility/bank-statement",
  [ApplicantStage.AwaitingApproval]:      "/eligibility/under-review",
  [ApplicantStage.Approved]:              "/eligibility/congratulations",
  [ApplicantStage.SanctionTermsAccepted]: "/eligibility/selfie",
  [ApplicantStage.Selfie]:                "/eligibility/agreement",
  [ApplicantStage.Agreement]:             "/eligibility/emandate",
  [ApplicantStage.BsDone]:               "/eligibility/digilocker",
  [ApplicantStage.FundSourceAssigned]:    "/eligibility/evaluating",
  [ApplicantStage.Rejected]:              "/eligibility/rejected",
};

export function usePreventBack(userId?: string, applicationId?: string) {
  const navigate = useNavigate();

  useEffect(() => {
    // Duplicate the current history entry so the first back press lands on
    // the same URL — React Router won't change the rendered component.
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      // Immediately re-push so the browser stays on the current URL
      window.history.pushState(null, "", window.location.href);

      // Resolve user identifiers (params take priority, fall back to session)
      let uid = userId;
      let appId = applicationId;
      if (!uid || !appId) {
        const saved = JSON.parse(sessionStorage.getItem("eligibility_data") || "{}");
        uid = saved?.userId;
        appId = saved?.applicationId;
      }
      if (!uid || !appId) return;

      const token = sessionStorage.getItem("eligibility_auth_token");
      const navData = { userId: uid, applicationId: appId };

      axios
        .get(
          `${process.env.REACT_APP_DASHBOARD_URL}/admin/application/stage?applicationId=${appId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          const stage: number = res?.data?.data?.stage;
          if (stage === undefined) return;

          if (stage === ApplicantStage.BsDone) {
            navigate("/eligibility/digilocker", { replace: true, state: { data: navData } });
          } else if (stage === ApplicantStage.BankStatement) {
            navigate("/eligibility/waiting", { replace: true, state: { data: navData, nextRoute: "/eligibility/digilocker" } });
          } else if (stage === ApplicantStage.Digilocker) {
            navigate("/eligibility/waiting", { replace: true, state: { data: navData, fromStage10: true } });
          } else if (STAGE_ROUTES[stage]) {
            navigate(STAGE_ROUTES[stage], { replace: true, state: { data: navData } });
          }
        })
        .catch(() => {
          // API failed — pushState already kept the browser on the current URL
        });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
}
